import { render, staticRenderFns } from "./patEV2.vue?vue&type=template&id=8adcf654&scoped=true&"
import script from "./patEV2.vue?vue&type=script&lang=js&"
export * from "./patEV2.vue?vue&type=script&lang=js&"
import style0 from "./patEV2.vue?vue&type=style&index=0&id=8adcf654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adcf654",
  null
  
)

export default component.exports